import React from "react";
import { Check, X } from "lucide-react";

export const EvidenceBoundary = ({ shared = [], withheld = [] }) => {
    return (
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-[var(--rule)]" data-testid="evidence-boundary">
            <div className="panel" style={{ border: "none" }}>
                <div className="px-6 sm:px-8 py-5 border-b hairline flex items-center justify-between">
                    <div>
                        <p className="mono-label">Step 04 · Evidence boundary</p>
                        <h3
                            className="font-serif mt-1"
                            style={{ fontSize: 22, letterSpacing: "-0.01em" }}
                        >
                            Shared for review
                        </h3>
                    </div>
                    <span
                        className="mono-label border border-[var(--forest)] px-2 py-1"
                        style={{ color: "var(--forest)" }}
                    >
                        {shared.length} refs
                    </span>
                </div>
                <ul className="px-6 sm:px-8 py-5 space-y-3">
                    {shared.map((e) => (
                        <li
                            key={e.key}
                            className="flex items-start gap-3 py-2 border-b hairline last:border-b-0"
                            data-testid={`shared-${e.key}`}
                        >
                            <Check
                                size={16}
                                strokeWidth={1.5}
                                style={{ color: "var(--forest)", marginTop: 2 }}
                            />
                            <div className="flex-1">
                                <p style={{ fontSize: 14.5 }}>{e.label}</p>
                                {e.ref && (
                                    <p
                                        className="mono-data mt-1"
                                        style={{
                                            fontSize: 11.5,
                                            color: "var(--ink-muted)",
                                        }}
                                    >
                                        {e.ref}
                                    </p>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="withheld-pattern" style={{ border: "none" }}>
                <div className="px-6 sm:px-8 py-5 border-b hairline flex items-center justify-between">
                    <div>
                        <p className="mono-label">Patient-controlled</p>
                        <h3
                            className="font-serif mt-1"
                            style={{ fontSize: 22, letterSpacing: "-0.01em" }}
                        >
                            Withheld
                        </h3>
                    </div>
                    <span
                        className="mono-label border border-[var(--ink)] px-2 py-1 bg-white"
                        style={{ color: "var(--ink)" }}
                    >
                        {withheld.length} categories
                    </span>
                </div>
                <ul className="px-6 sm:px-8 py-5 space-y-3">
                    {withheld.map((e) => (
                        <li
                            key={e.key}
                            className="flex items-start gap-3 py-2 border-b hairline last:border-b-0"
                            data-testid={`withheld-${e.key}`}
                        >
                            <X
                                size={16}
                                strokeWidth={1.5}
                                style={{ color: "var(--ink)", marginTop: 2 }}
                            />
                            <p style={{ fontSize: 14.5, color: "var(--ink)" }}>
                                {e.label}
                            </p>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default EvidenceBoundary;
